import { RouterProvider } from 'react-router';
import { useBackgroundSync } from '@/features/sync-status/hooks/use-background-sync';
import { useLocale } from '@/shared/i18n/use-locale';
import { Toaster } from '@/shared/ui/sonner/toaster';
import { TooltipProvider } from '@/shared/ui/tooltip/tooltip-provider';
import { usePwaUpdates } from './providers/use-pwa-updates';
import { router } from './router/router';

export function App() {
  useBackgroundSync();
  usePwaUpdates();
  // Changing the language re-renders everything, so text translated outside a hook is never stale.
  const locale = useLocale();
  return (
    <TooltipProvider key={locale}>
      <RouterProvider router={router} />
      <Toaster position="top-center" />
    </TooltipProvider>
  );
}
